import { http } from '@pendo/http';
import get from 'lodash/get';

export function fetchPesConfiguration () {
    return http.get('api/s/_SID_/pesconfiguration');
}

export function patchPesConfiguration (update) {
    return http.patch('api/s/_SID_/pesconfiguration', update);
}

const validationConfig = [
    {
        path: 'adoption.userBase',
        type: 'string',
    },
    {
        path: 'growth.userBase',
        type: 'string',
    },
    {
        path: 'stickiness.userBase',
        type: 'string',
    },
    {
        path: 'stickiness.excludeWeekends',
        type: 'boolean',
    },
    {
        path: 'stickiness.numerator',
        type: 'string',
    },
    {
        path: 'stickiness.denominator',
        type: 'string',
    },
];

export function validateConfig (appPesConfig) {
    validationConfig.forEach((configRule) => {
        // eslint-disable-next-line valid-typeof
        if (typeof get(appPesConfig, `${configRule.path}`) !== configRule.type) {
            throw new Error(`Incorrect type for ${configRule.path} expected ${configRule.type}`);
        }
    });
}

export function validateExcludeWeekendsType (responseData) {
    const validatedData = responseData.map((appData) => {
        if (typeof appData.configuration.stickiness.excludeWeekends !== 'boolean') {
            appData.configuration.stickiness.excludeWeekends =
                appData.configuration.stickiness.excludeWeekends === 'true';
        }

        return appData;
    });

    return validatedData;
}

export function validateStickinessUserBaseType (responseData) {
    const validatedData = responseData.map((appData) => {
        if (typeof appData.configuration.stickiness.userBase !== 'string') {
            appData.configuration.stickiness.userBase = 'visitors';
        }

        return appData;
    });

    return validatedData;
}
